import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { tickStep } from 'd3';
export type PlusMinusString = string;

export interface DateWithinCountOfWhich {
	which: 'days' | 'weeks' | 'months'|'years';
	count: number;
	range: PlusMinusString;
}

@Component({
	selector: 'app-date-within-value',
	templateUrl: './date-within-value.component.html',
	styleUrls: ['./date-within-value.component.scss']
})
export class DateWithinValueComponent implements OnInit {

	public which: 'days' | 'weeks' | 'months' | 'years' = 'days';
	public numberOfWhich = 0;
	public minusRange = false;
	public plusRange = false;

	private defaultValue = {
		which: 'days',
		count: 0,
		range: '+'
	}

	public get value(): DateWithinCountOfWhich {
		let plusMinus: PlusMinusString = '';
		if (this.minusRange === true) {
			plusMinus += '-';
		}
		if (this.plusRange === true) {
			plusMinus += '+';
		}
		if (plusMinus === '') {
			plusMinus = '+';
		}
		return {
			which: this.which,
			count: this.numberOfWhich,
			range: plusMinus
		}
	}
	@Input('value')
	public set value(val) {
		if (!val) {
			val = JSON.parse(JSON.stringify(this.defaultValue));
		}
		switch (val.range) {
			case '-+':
				this.plusRange = true;
				this.minusRange = true;
				break;
			case '-':
				this.plusRange = false;
				this.minusRange = true;
				break;
			default:
			case '+':
				this.plusRange = true;
				this.minusRange = false;
				break;
		}
		this.numberOfWhich = val.count;
		this.which = val.which;
	}
	@Output() valueChange: EventEmitter<DateWithinCountOfWhich> = new EventEmitter<DateWithinCountOfWhich>();
	constructor() { }

	HandleMinus(val: boolean) {
		this.minusRange = val;
		this.NotifyListeners();
	}
	HandlePlus(val: boolean) {
		this.plusRange = val;
		this.NotifyListeners();
  }

  NotifyListeners() {
		this.valueChange.emit(this.value);
  }
	ngOnInit(): void {
	}

}
